import React from 'react';
import styled from 'styled-components';

const Checkbox = ({ id, checked = false, onChange, className = '', disabled = false }) => {
  return (
    <StyledWrapper className={className}>
      <label className="checkbox-wrapper" aria-disabled={disabled}>
        <input
          type="checkbox"
          id={id}
          checked={Boolean(checked)}
          onChange={onChange}
          disabled={disabled}
          style={{ position: 'absolute', opacity: 0, width: 30, height: 30, left: 0, top: 0, margin: 0, padding: 0 }}
        />
        <span className="checkmark" />
      </label>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .checkmark {
   display: block;
   width: 30px;
   height: 30px;
   background-color: var(--primary-color);
   border-radius: 10px;
   position: relative;
   transition: background-color 0.2s ease;
   cursor: pointer;
   will-change: background-color;
  }

  .checkbox-wrapper[aria-disabled="true"] {
    cursor: not-allowed;
    opacity: 0.6;
    pointer-events: auto;
  }

  input:checked ~ .checkmark {
   background-color: var(--secondary-color);
  }

  .checkmark::after {
   content: "";
   position: absolute;
   width: 5px;
   height: 10px;
   border-right: 3px solid #fff;
   border-bottom: 3px solid #fff;
   top: 44%;
   left: 50%;
   transform: translate(-50%, -50%) rotateZ(40deg) scale(0);
   opacity: 0;
   transition: transform 0.2s ease, opacity 0.15s ease;
   will-change: transform, opacity;
  }

  input:checked ~ .checkmark::after {
   opacity: 1;
   transform: translate(-50%, -50%) rotateZ(40deg) scale(1);
  }
`;

export default Checkbox;
